import * as React from "react";
import {Router} from "react-router";


export default class IcomRouter extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        // Server?
        const serverRender = typeof window === 'undefined';

        if (serverRender) {

            return (

                <React.Fragment>
                    {this.props.children}
                </React.Fragment>

            );
        } else {
            return (
                <Router {...this.props} >
                    {this.props.children}
                </Router>
            );
        }
    }
}
